import React from "react";
import styled from "styled-components";
import colors from "../config/colors";

import Headline from "../components/Headline";
import Row from "../components/Row";
import Strong from "../components/Strong";
import Button from "../components/Button";
import ContentSection from "../components/ContentSection";
import Me from "../components/Me";
import Tech from "../components/Tech";

export default () => (
  <ContentSection id="about">
    <Headline>
      Über <Strong>mich</Strong>
    </Headline>
    <Row>
      <Me />
      <Tech />
    </Row>
  </ContentSection>
);



// WEBPACK FOOTER //
// ./src/components/About.js